import { render, staticRenderFns } from "./TaskSeriesTable.vue?vue&type=template&id=405e96bb&scoped=true"
import script from "./TaskSeriesTable.vue?vue&type=script&lang=js"
export * from "./TaskSeriesTable.vue?vue&type=script&lang=js"
import style0 from "./TaskSeriesTable.vue?vue&type=style&index=0&id=405e96bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405e96bb",
  null
  
)

export default component.exports